<ngx-charts-pie-chart [gradient]="true" [labels]="false" [legend]="true" [legendPosition]="position"
  [legendTitle]="''" [results]="data" [scheme]="colorScheme" [view]="[322, 246]" (select)="onSelect($event)">
</ngx-charts-pie-chart>
